import {
  QUESTION_BANK_ADD_PATH,
  QUESTION_BANK_EDIT,
  QUESTION_BANK_PATH,
  QUESTION_BANK_VIEW,
  ROOT,
  NO_PERMISSION_PATH,
} from 'constant/path';
import React, { useEffect, useMemo } from 'react';
import { useLocation, useNavigate } from 'react-router';
import { useAppSelector } from 'reducers/models';
import { roleConstant, transformDataRole } from 'role/constant';
import useTitle from 'hooks/useTitle';
import { SideBarTitle } from 'utils/helperFunctions';

interface IQuestionBankProtectedWrapperProps {
  children: React.ReactNode;
}

const QuestionBankProtectedWrapper: React.FC<IQuestionBankProtectedWrapperProps> = ({
  children,
}) => {
  useTitle(SideBarTitle.QUESTION_BANK);
  const location = useLocation();
  const navigate = useNavigate();
  const isLoading = useAppSelector((state) => state.auth.isLoading);
  const questionBankAuthorization = useAppSelector((state) => state.auth.questionBankAuthorization);
  const questionBankRole = useMemo(
    () => transformDataRole(questionBankAuthorization),
    [JSON.stringify(questionBankAuthorization)]
  );

  const handleNavigate = () => {
    const currentPathName = location.pathname;
    if (isLoading) {
      return;
    }
    if (questionBankRole[roleConstant.all]) {
      return;
    }
    if (currentPathName.includes(QUESTION_BANK_ADD_PATH) && !questionBankRole[roleConstant.add]) {
      navigate(`${ROOT}${NO_PERMISSION_PATH}`);
      return;
    }
    if (currentPathName.includes(QUESTION_BANK_EDIT)) {
      if (questionBankRole[roleConstant.edit] || questionBankRole[roleConstant.copy]) {
        return;
      }
      navigate(`${ROOT}${NO_PERMISSION_PATH}`);
      return;
    }
    if (currentPathName.includes(QUESTION_BANK_VIEW) && !questionBankRole[roleConstant.view]) {
      navigate(`${ROOT}${NO_PERMISSION_PATH}`);
      return;
    }
  };
  useEffect(() => {
    handleNavigate();
  }, [location.pathname, isLoading]);

  return <>{children}</>;
};

export default QuestionBankProtectedWrapper;
